import {
    Box,
    Container,
    Typography,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItem,
    ListItemText
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

export const Privacy = () => {
    return(
        <Container maxWidth="lg">
            <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
                Privacy Policy
            </Typography>
            
            <Paper elevation={2} sx={{ p: 4, mb: 3 }}>
                <Typography variant="body1" paragraph>
                    The following policy applies to users of kmeeraj.com and is intended to explain what types of information is gathered from users and how that information is used.
                </Typography>
                <Typography variant="body1" paragraph>
                    The kmeeraj.com is committed to respecting your privacy. As an unregistered user, you can visit most of kmeeraj.com without revealing any personal information. We do not collect any personal information about you unless you provide that information voluntarily. Any personal information you choose to provide us will only be used by kmeeraj.com to conduct official kmeeraj.com business. kmeeraj.com does not sell, rent, loan, trade or lease personal information collected on this site.
                </Typography>
                <Typography variant="body1" paragraph>
                    For purposes of this policy, ''personal information'' means any information concerning a natural person which, because of name, number, symbol, mark or other identifier, can be used to identify that natural person.
                </Typography>
            </Paper>
            
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">INFORMATION COLLECTED AND STORED AUTOMATICALLY</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box>
                        <Typography variant="h6" gutterBottom>Cookies</Typography>
                        <Typography variant="body1" paragraph>
                            A cookie is a piece of text placed on your computer by a web server. We occasionally use ''session'' cookies on some parts of kmeeraj.com to enhance your experience of the site and to help you move through it easily. Session cookies created on your computer by kmeeraj.com servers do not contain personal information. We may use a session cookie to store a randomly generated identifying tag on your computer. Session cookies are temporary and are automatically deleted during operation of your browser or when your browser is closed.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Most web browsers may be customized to refuse new cookies or delete existing cookies. Rejecting or deleting cookies may limit your ability to take advantage of some features of this web site and could result in the loss of any customized setting.
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">Logs and Network Monitoring</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box>
                        <Typography variant="body1" paragraph>
                            We maintain log files of all access to kmeeraj.com and also monitor network traffic for purposes of site management and security. We use this information to help diagnose problems with the server and to carry out other administrative tasks. We also use log analysis tools for such purposes as creating summary statistics to determine which information is of most interest to users, identifying system problem areas, and determining technical requirements. The following information is typically collected in these files:
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemText primary="the Internet Protocol address and domain name of your Internet Service Provider and/or computer, if your computer has an IP address assigned directly to it;" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="the type of browser and operating system you use;" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="the date and time you visited kmeeraj.com;" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="the web pages or services you accessed at kmeeraj.com and amount of time spent at each page; and" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="the web page from which you accessed kmeeraj.com and from which any page on this site was linked." />
                            </ListItem>
                        </List>
                        <Typography variant="body1" paragraph>
                            None of the foregoing information is deemed to constitute personal information per the Internet Privacy and Security Act.
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">INFORMATION COLLECTED BY EMAIL AND ONLINE TRANSACTIONS</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1" paragraph>
                        If you send us an email, we will collect your email address and the contents of your message. We will use your email address and the information included in your message to respond to you, to address the issues you identify, and to improve this web site. We may also use your email address to notify you about updates, services, special events or activities offered by kmeeraj.com.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        If you complete a transaction such as an online application or an information request form, we will collect the information, including personal information, that you volunteered in completing the transaction. We will use this information only for the purposes for which the transaction was intended.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We may redirect your email message or information you provided through an online transaction to a kmeeraj.com office other than the one which originally received the message or information in order to better respond to you.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        The information we collect is not limited to text characters and may include audio, video and graphic information formats included in the message or transaction.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We do not knowingly collect personal information from children under the age of 13. You are cautioned, however, that we will treat personal information submitted in an email as though it was submitted by an adult, and it may, unless exempted from access by federal or state law, be subject to public access.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">DISCLOSURE OF INFORMATION COLLECTED THROUGH THIS WEB SITE</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1" paragraph>
                        We may collect or disclose personal information without your consent if the collection or disclosure is:
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemText primary="necessary to perform kmeeraj.com statutory duties or necessary to operate a program authorized by law, or authorized by state or government statute or regulation;" />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="made pursuant to a court order or by law;" />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="for the purpose of validating your identity; or" />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="of information to be used solely for statistical purposes that is in the form that cannot be used to identify any particular person." />
                        </ListItem>
                    </List>
                    <Typography variant="body1" paragraph>
                        Further, the disclosure of information, including personal information, collected through this website is subject to the provisions of the Information Technology Act (ITA) 2000.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We may also disclose personal information to federal or state law enforcement authorities to enforce kmeeraj.com's rights against unauthorized access or attempted unauthorized access to kmeeraj.com information technology assets.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">RETENTION OF INFORMATION COLLECTED THROUGH THIS WEBSITE</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1">
                        We retain the information collected through this web site in accordance with the kmeeraj.com records retention and disposition policy. The retention period differs depending on the type of information collected. Questions regarding the records retention and disposition policy should be addressed to: meeraj.kanaparthi@gmail.com
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">ACCESS TO AND CORRECTION OF PERSONAL INFORMATION COLLECTED THROUGH THIS WEBSITE</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1">
                        You may submit a request to the kmeeraj.com records access officer to determine whether personal information pertaining to you has been collected through this web site. Your request must be in made in writing and must be accompanied by reasonable proof of your identity. Reasonable proof of identity may include verification of a signature, inclusion of an identifier generally known only to you, or similar appropriate identification.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">CONFIDENTIALITY AND INTEGRITY</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1" paragraph>
                        We limit employee access to personal information collected through kmeeraj.com to only those employees who need access to the information in the performance of their official duties. Employees who have access to this information follow appropriate procedures in connection with any disclosures of personal information.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        In addition, we have implemented procedures to safeguard the integrity of kmeeraj.com's information technology assets, including, but not limited to, authentication, authorization, monitoring, auditing, and encryption. These security procedures have been integrated into the design, implementation, and day-to-day operations of kmeeraj.com as part of our continuing commitment to the security of electronic content as well as the electronic transmission of information.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        For security purposes and to maintain the availability of kmeeraj.com for all users, we we employ software to monitor traffic to identify unauthorized attempts to upload or change information or otherwise damage this web site.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">LINKS TO THIRD-PARTY SITES</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1">
                        kmeeraj.com may contain links to, and may be linked from, sites outside of kmeeraj.com. We are not responsible for the privacy practices, terms of use, or the content of such web sites. A link to an outside web site from kmeeraj.com does not constitute an endorsement or sponsorship of such web site or its content.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">CHANGES TO POLICY AND DISCLAIMER</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1">
                        We may change this policy from time to time, and reserve the right to do so without notice. The information provided in this privacy policy should not be construed as giving business, legal or other advice, or warranting as fail proof, the security of information provided through kmeeraj.com
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">CONTACT INFORMATION</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1">
                        For questions regarding this privacy policy, please contact: meeraj.kanaparthi@gmail.com
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}